import React, { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";

export type StatCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  className?: string;
  bg?: string; // tailwind background class (e.g. "bg-blue-50")
  iconbg?: string;
  iconcolor?: string; 
};




const StatCard: React.FC<StatCardProps> = ({ title, value, icon, className = "", bg = "bg-gray-50", iconbg ="bg-gray-50" ,iconcolor="text-gray-50"}) => {

  return (
    <div className={`${bg} rounded-2xl p-4 shadow-sm flex items-start gap-4 overflow-hidden ${className}`}>
     

      <div className="flex-1">
        <div className="text-sm text-gray-500">{title}</div>
        <div className="mt-2 text-xl font-bold">{value}</div>
        {/* {subtitle && <div className="text-xs text-gray-400 mt-1">{subtitle}</div>} */}
      </div>
       <div className="flex-shrink-0">
        <div className={`w-12 h-12 rounded-2xl  flex items-center justify-center shadow ${iconbg} ${iconcolor}`}>
          {icon ?? <span className={` text-lg`}>📊</span>}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
